import axios from './axios';
import config from '../../helpers/config';

export default (name, email, phone, extension) => (
  axios.post(
    config.designBuilderSaveDcSignature,
    {
      DcId: config.repId(),
      SiteId: config.siteId,
      Name: name,
      Email: email,
      Phone: phone,
      Extension: extension,
    },
  )
);
